<template>
  <el-dialog  :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" top="140px">
    <div style="height: 400px;">
        <div style="width: 100%; margin-top: 50px; overflow: hidden;">
          <div style="float: left; width: 50%; text-align: center;">
            <div style="text-align: center;">
              <img style="width: 300px; height: 300px;" src="../../../assets/img/applet/applet-purchase.jpg"/>
            </div>
            <div style="font-size: 25px; font-weight: 600; color: rebeccapurple;">采购商小程序码</div>
          </div>

          <div style="float: left; width: 50%; text-align: center;">
            <div style="text-align: center;">
              <img style="width: 300px; height: 300px;" src="../../../assets/img/applet/applet-supplier.jpg"/>
            </div>
            <div style="font-size: 25px; font-weight: 600; color: rebeccapurple;">供应商小程序码</div>
          </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <xr-button type="default" @click="dialogVisible = false">关闭</xr-button>
    </div>
  </el-dialog>
</template>

<script>


export default {
  name: 'inStockAddOrEdit',
  data() {
    return {
      dialogName: '小程序码',
      dialogVisible: true,
      type: '',
      category_list:[],                  //分类列表
      service_list:[],                   //服务列表
      purchaseOrgId_list: [],            //采购商
      goodsStats_list:[],                //属性列表
      goodsStats: [],                    //选中的属性
      serviceIds: [],                    //选中的服务
      isComboBuyShow: false,
      mainImgList: [],
    }
  },
  components: {

  },
  methods: {
    //初始化页面
    init(type, id) {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('close')  // 触发关闭事件
    },
    buy(){
      this.isComboBuyShow = true;
      this.$nextTick(()=>{
        this.$refs.comboBuy.init() //初始化页面
      })
    }
  }
}
</script>

<style scoped>

/* 给提示文字加个类名，使其在样式上与其他内容区分开来 */
.hint-text {
  font-size: 14px;
  color: #a9a9ab;
  /*margin-bottom: 15px;*/
  margin-top: 5px;
}

  .remind-content{
    font-family: "华文行楷", "STXingkai", "Xingkai SC", "Kaiti SC", cursive;
    font-size: 40px;
    text-align: center;
    margin-top: 200px;
    font-weight: 600;
  }

  .remind-date{
    text-align: center;
    margin-top: 100px;
    color: red;
    font-size: 25px;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/views/base/applet/appletImg.vue